<script>
import { mapGetters, mapActions } from 'vuex'
import Roles from '@/mixins/Roles'
import Filter from './Filter'
import * as userMutations from '@/store/modules/users/mutations'

export default {
    mixins: [Roles],

    data() {
        return {
            per_page: 10,
        }
    },

    computed: mapGetters({
        users: 'users',
        search: 'search',
        filters: 'filters',
    }),

    watch: {
        search: 'page',
        filters: 'page',
    },

    mounted() {
        this.$store.commit(userMutations.UPDATE_USER, { data: [] })
        this.page(1)
        this.$store.dispatch('filterComponent', Filter)
    },

    methods: {
        ...mapActions({
            impersonate: 'authImpersonate',
            suspend: 'usersSuspend',
            resume: 'usersResume',
            delUser: 'usersDelete',
        }),

        page(n) {
            this.$store.dispatch('usersFetchList', {
                page: n,
                per_page: this.per_page,
                search: this.search,
                filters: this.filters,
            })
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    template(slot="heading")
        acrm-heading.mr-2.mb-0(:level="3") {{ $t('USERS.USERS') }}
        span {{ $t('USERS.NUM_USERS', { num: users && users.meta && users.meta.total ? users.meta.total : 0 })}}
        acrm-input-button.ml-auto.block-xs.mt-2.mt-sm-0(
            @click="$router.push({name: 'users-create'})"
            v-if="hasRole('user.create')"
        ) {{ $t('USERS.CREATE') }}

    template(v-if="users && users.data && users.meta && users.meta.current_page != undefined")
        table.table.table-striped.table-hover()
            thead
            tbody
                tr(v-for="user in users.data" :key="user.id")
                    td
                        .row
                            .col
                                .flex-center-v.mb-2
                                    acrm-badge.mr-2(icon="person")
                                    router-link(:to="{name: 'users-view', params: { user: user.id }}")
                                        acrm-heading.mb-0(:level="6") {{ user.display_name }}
                                .d-flex.flex-wrap
                                    .flex-center-v.mr-4.mt-2.mt-lg-0
                                        acrm-badge.px-2.py-1.mr-2(variant="light")
                                            icon(name="work")
                                            span.ml-2 {{ $t('COMPANIES.NUM_COMPANIES', { num: user.companies ? user.companies.length : 0 }) }}
                                        acrm-badge.px-2.py-1.mr-2(variant="light")
                                            icon(name="drive_eta")
                                            span.ml-2 {{ $t('CARS.NUM_CARS', { num: user.cars ? user.cars.length : 0 }) }}
                                    .flex-center-v.mr-4.mt-2.mt-lg-0.f.flex-wrap
                                        acrm-heading.block-xs.mb-0.mr-2(:level="6") {{ $t('BASE.BASEDATA') }}:
                                        span.mr-2 {{ user.email }}
                                        span.mr-2 {{ user.phone }}
                                        span {{ user.type }}
                            .col-auto.d-inline-flex.align-items-center
                                acrm-input-button-dropdown(
                                    variant="link" icon="more_horiz" no-handle large align-right
                                    v-if="hasRole('user.impersonate') || hasRole('user.suspend') || hasRole('user.delete')"
                                    )
                                    acrm-input-dropdown-item(icon="exit_to_app" @click="impersonate(user.id)" v-if="hasRole('user.impersonate')") {{ $t('USERS.IMPERSONATE') }}
                                    acrm-input-dropdown-item(icon="block" @click="suspend(user)" v-if="user.is_enabled && hasRole('user.suspend')") {{ $t('USERS.ACCOUNT_SUSPEND') }}
                                    acrm-input-dropdown-item(icon="play_arrow" @click="resume(user)" v-if="!user.is_enabled && hasRole('user.suspend')") {{ $t('USERS.ACCOUNT_RESUME') }}
                                    acrm-input-dropdown-item(icon="delete" @click="delUser(user)" v-if="hasRole('user.delete')")  {{ $t('USERS.ACCOUNT_DELETE') }}
    acrm-paginate(:data="users.meta" @page="page")
</template>
